import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { apiRequest } from "../../pages/api/requestHelper";
import config from "../config/app.json";
import Link from "next/link";
import { useRouter } from "next/router";
import { getPathName, getContextPath } from "../helpers/utils";

const SearchBarContainer = styled.div`
  display: flex;
  width: 100%;
  background: #f7f7f7;
  border-radius: 24px;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
  ${(props) =>
    props.searchBarStyle &&
    props.searchBarStyle === "home" &&
    `
      border-radius: 4px;
      flex-direction: row-reverse;
      input {
        border-radius: 4px;
      }
      width: 75%;
      display: flex;
      justify-content: flex-end;
      @media(max-width: 425px) {
        width: 100%;
      }
  `}
`;
const SearchBarInput = styled.input`
  font-size: 1em;
  border-radius: 24px;
  padding: 10px 20px;
  border: 0;
  background: #f7f7f7;
  outline: 0;
  width: 80%;
  color: #2d2d2d;
  font-family: "Lato";
  font-size: 15px;
  text-transform: capitalize;
  ::placeholder {
    color: #d5d5d5;
  }
  ${(props) =>
    props.searchBarStyle &&
    props.searchBarStyle === "home" &&
    `
      @media(max-width: 425px) {
        padding: 10px 0px;
      }
  `}
`;

const OverLay = styled.div`
  position: fixed;
  top: 65px;
  height: 100%;
  width: 100%;
  background: #000;
  opacity: 0.7;
  left: 0;
  display: none;
  @media (max-width: 425px) {
    display: block;
  }
`;

const SearchInputIcon = styled.img`
  width: ${(props) => (props.width ? props.width : "18px")};
  height: ${(props) => (props.height ? props.width : "18px")};
  margin: 0px 20px;
  cursor: pointer;
`;

const DropDownList = styled.ul`
  position: absolute;
  padding: 0px;
  top: 25px;
  width: ${(props) => (props?.searchBarStyle === "home" ? "75%" : "100%")};
  border-radius: ${(props) =>
    props?.searchBarStyle === "home" ? "0px" : "5px"};
  max-height: 400px;
  overflow-y: scroll;
  background-color: #f7f7f7;
  z-index: 1;
  ${(props) =>
    props?.searchBarStyle === "home" &&
    `@media(max-width: 425px) {
    width: 100%;
  }`}
`;

const DropDownListItem = styled.li`
  list-style: none;
  cursor: pointer;
  border-left: ${(props) =>
    props.active === "active" ? `6px solid #ffc101` : `6px solid #f7f7f7`};
  background-color: ${(props) => props.active === "active" && `#eaebef`};
  a {
    text-decoration: none;
    color: #424242;
    width: 100%;
  }
`;

const DropDownLogo = styled.img`
  width: 30px;
  height: 30px;
  margin: 0px 10px 0px 0px;
`;

const DropDownOptions = styled.span`
  display: flex;
  align-items: center;
  padding: 10px;
`;

const SearchListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  ${(props) =>
    props.searchBarStyle &&
    props.searchBarStyle === "home" &&
    `
    width: 75%;
    display: flex;
    align-items: center;
    height: 50px;
  `}
  ${(props) =>
    props.searchBarStyle !== "home" &&
    `@media(max-width: 425px) {
    width: 90%;
    margin: 0 auto !important;
  }`}
`;

const appUrl = config["APPURLS"][config["APPURLS"]["current"]];
const apiUrl = config["APIURIS"][config["APIURIS"]["current"]];
const BASE_PATH = process.env.BASE_PATH;

function SearchBar(props) {
  const { searchBarStyle, variants } = props;
  const router = useRouter();
  const [searchBarData, setSearchBarData] = useState([]);
  const [tempSearchData, setTempSearchData] = useState([]);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [toShowList, setToShowList] = useState(false);
  const inputRef = useRef(null);
  const liRef = useRef(null);
  const [cursor, setCursor] = useState(-1);
  const name = router.query.id ? getPathName(router.query.id) : "";

  const handleNavigation = useCallback((props) => {
    if (props.query) {
      window.scrollTo(0, 0);
      return router.push({
        pathname: `/search/`,
        query: props.query,
      });
    } else {
      window.scrollTo(0, 0);
      return router.push({
        pathname: `/${props.pathname}`,
      });
    }
  });

  useEffect(() => {
    getTemplateOptions();
    setSearchKeyWord(name);
  }, [name]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        if (liRef.current && liRef.current.contains(event.target)) {
          const element =
            event.target.tagName.toLowerCase() === "img"
              ? {
                  textContent: event.target.parentElement.textContent,
                  id: event.target.parentElement.id,
                }
              : { textContent: event.target.textContent, id: event.target.id };
          setSearchKeyWord(element.textContent);
        }
        if (event.target.id !== "close_icon") {
          setToShowList(false);
          if (
            event.target.parentElement &&
            event.target.parentElement.id !== "header-search-icon" &&
            props.setShowSearch
          ) {
            props.setShowSearch(false);
          }
        }
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [inputRef]);

  useEffect(() => {
    if (
      tempSearchData.length &&
      cursor >= 0 &&
      cursor <= tempSearchData.length - 1
    ) {
      setSearchKeyWord(
        tempSearchData[cursor]["_source"]
          ? tempSearchData[cursor]["_source"].name
          : tempSearchData[cursor][name]
      );
    }
  }, [cursor]);

  async function getTemplateOptions() {
    let searchData = [];

    if (props.data) {
      searchData = props.data;
    } else {
      const { data } = await apiRequest("post", `${apiUrl}dynamic/`);
      searchData =
        !!data["data"] && !!data["data"]["design_category"]
          ? data["data"]["design_category"]
          : [];
    }

    setSearchBarData(searchData);
    setTempSearchData(searchData);
  }

  async function getOptions(searchTag) {
    if (inputRef.current.value === "") {
      setTimeout(() => {
        setTempSearchData(searchBarData);
      });
      return;
    }

    const _searchTag = encodeURIComponent(searchTag);

    const { data } = await apiRequest(
      "get",
      `${apiUrl}dynamic/search/?query=${_searchTag}`
    );

    setTempSearchData(data["data"]);
  }

  function debounce(fn, delay, searchTag) {
    let timer;

    return function () {
      let context = this;
      let args = arguments;
      clearTimeout(timer);

      timer = setTimeout(() => {
        fn.apply(context, args, searchTag);
      }, delay);
    };
  }

  const _debounce = useCallback(
    debounce(getOptions, 300, inputRef?.current?.value),
    []
  );

  function toggleList() {
    if (!toShowList) {
      setToShowList(true);
    }
  }

  function handleOnClick() {
    toggleList();
  }

  function handleOnChange() {
    setSearchKeyWord(inputRef.current.value);
    setCursor(-1);
    _debounce(inputRef.current.value);
    toggleList();
  }

  function handleClearClick() {
    setSearchKeyWord("");
    setTempSearchData(searchBarData);
  }

  function handleKeyDown(event) {
    const element = liRef.current;
    if (tempSearchData.length && event.keyCode === 40) {
      setCursor((prevState) =>
        prevState < tempSearchData.length - 1 ? prevState + 1 : prevState
      );
      if (cursor > 4) {
        element.scrollTop += 50;
      }
    } else if (tempSearchData.length && event.keyCode === 38) {
      setCursor((prevState) => (prevState > 0 ? prevState - 1 : prevState));
      if (cursor < tempSearchData.length - 4) {
        element.scrollTop -= 50;
      }
    } else if (event.keyCode === 13) {
      setToShowList(false);
      if (cursor !== -1) {
        const filteredData = tempSearchData[cursor]["_source"]
          ? tempSearchData[cursor]["_source"]
          : tempSearchData[cursor];
        handleNavigation({
          pathname: filteredData.page_url,
        });
      } else {
        if (inputRef.current.value.trim() !== "") {
          handleNavigation({
            pathname: "/",
            query: { id: getContextPath(inputRef.current.value) },
          });
        }
      }
    }
  }

  return (
    <SearchListWrapper searchBarStyle={searchBarStyle} variants={variants}>
      <SearchBarContainer
        searchBarStyle={searchBarStyle}
        onClick={handleOnClick}
      >
        <SearchBarInput
          ref={inputRef}
          autoComplete="off"
          id="search_icon"
          placeholder="Search for Instagram story, A4…"
          onChange={handleOnChange}
          onKeyDown={handleKeyDown}
          value={searchKeyWord}
          searchBarStyle={searchBarStyle}
        />
        {searchKeyWord !== "" ? (
          <SearchInputIcon
            type="close"
            width="13px"
            height="13px"
            alt="close_icon"
            id="close_icon"
            title="close_icon"
            onClick={handleClearClick}
            src={`${BASE_PATH}/images/icon-close.svg`}
          />
        ) : (
          <SearchInputIcon
            id="search-icon"
            type="search"
            alt="search_icon"
            title="search_icon"
            src={`${BASE_PATH}/images/icon-search.svg`}
          />
        )}
      </SearchBarContainer>
      {toShowList && (
        <DropDownList ref={liRef} searchBarStyle={searchBarStyle}>
          {tempSearchData.map((data, index) => {
            const { page_url, img, name } = data["_source"]
              ? data["_source"]
              : data;
            return (
              <DropDownListItem
                key={index}
                active={index === cursor ? "active" : ""}
              >
                <Link href={`/${page_url}`} passHref>
                  <a onClick={() => window.scrollTo(0, 0)}>
                    <DropDownOptions id={page_url}>
                      <DropDownLogo
                        src={`${appUrl}static/imagesizes/${img}`}
                        title={name}
                        alt={name}
                      />
                      {name}
                    </DropDownOptions>
                  </a>
                </Link>
              </DropDownListItem>
            );
          })}
        </DropDownList>
      )}
      {toShowList && searchBarStyle !== "home" && <OverLay />}
    </SearchListWrapper>
  );
}

export default React.memo(SearchBar);
